module.exports = __webpack_public_path__ + "img/alipay.44316193.svg";